/**
 * List all possible events we track
 */
export enum CommunicationSessionEventLogSendMessageType {
  reservationOffer = 'reservationOffer',
  notification = 'notification',
}
